import { useState } from 'react';

const fiscalYearModel = () => {
  const initialState = {
    id: 0,
    fiscalYear: '',
    yearlyTotalWorkingDays: null,
    totalWorkingDays: [],
  };

  const [fiscalYear, setFiscalYear] = useState(initialState);

  return {
    fiscalYear,
    setFiscalYear,
    initialState,
  };
};
export default fiscalYearModel;
